(() => {
  const STORAGE_KEY = 'mcor_fit_guide_vehicle_v1';
  const PARAMS = {
    year: 'fg_year',
    make: 'fg_make',
    model: 'fg_model',
    submodel: 'fg_submodel',
    body_style: 'fg_body',
    screen: 'fg_screen',
    amplifier: 'fg_amp',
    hvac: 'fg_hvac',
    key_type: 'fg_key',
    transmission: 'fg_trans',
    powertrain: 'fg_powertrain',
  };

  const savedVehicle = () => {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (_error) {
      return null;
    }
  };

  const fitGuideUrl = (path) => {
    const url = new URL(path || '/pages/speaker-fit-guide', window.location.origin);
    const vehicle = savedVehicle();
    if (!vehicle?.year || !vehicle?.make || !vehicle?.model) return url.pathname;

    Object.entries(PARAMS).forEach(([field, parameter]) => {
      if (vehicle[field]) url.searchParams.set(parameter, vehicle[field]);
    });
    return `${url.pathname}${url.search}`;
  };

  const updateFitGuideLinks = () => {
    document.querySelectorAll('[data-mcor-fit-guide-link]').forEach((link) => {
      const root = link.closest('[data-mcor-purchase-guide]');
      link.href = fitGuideUrl(root?.dataset.fitGuideUrl || link.getAttribute('href'));
    });
  };

  const setupStickyPurchase = (sticky) => {
    const source = document.getElementById(sticky.dataset.submitButton);
    const proxy = sticky.querySelector('[data-mcor-mobile-submit]');
    if (!source || !proxy || !('IntersectionObserver' in window)) return;

    const sync = () => {
      const label = source.querySelector('span')?.textContent?.trim() || 'Add to cart';
      proxy.querySelector('span').textContent = label;
      proxy.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
    };

    const updateVisibility = () => {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        sticky.hidden = true;
        return;
      }
      const rect = source.getBoundingClientRect();
      sticky.hidden = !(rect.bottom < 0);
    };

    proxy.addEventListener('click', () => {
      sync();
      if (!proxy.disabled) source.click();
    });

    new MutationObserver(sync).observe(source, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    new IntersectionObserver(updateVisibility, { threshold: 0 }).observe(source);
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    sync();
    updateVisibility();
  };

  const init = () => {
    updateFitGuideLinks();
    document.querySelectorAll('[data-mcor-mobile-purchase]').forEach(setupStickyPurchase);
  };

  document.addEventListener('DOMContentLoaded', init, { once: true });
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) updateFitGuideLinks();
  });
  document.addEventListener('mcor:vehicle-changed', updateFitGuideLinks);
})();
